import { Link } from 'react-router-dom';
//import LogoTitle from '../../assets/images/logo-s.png';
import './index.scss'
import { useEffect, useState } from 'react';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './Logo'
import Loader from 'react-loaders';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = [' ', 'D', 'a', 'n', 'i', 'e', 'l']
    const jobArray = ['m', 'a', 't', 'h', 'e', 'm', 'a', 't', 'i', 'c', 'i', 'a', 'n', ' ', '&', ' ', 'd', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r', '.']

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 5500)

        return () => clearTimeout(timeoutId)

    }, [])

    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={'letterClass'}>H</span>
                <span className={`${letterClass} _12`} >i</span>    
                <br />
                <span className={`${letterClass} _13`} >I</span>   
                <span className={`${letterClass} _14`} >'m</span>   
                {/* <img src={LogoTitle} alt='developer' /> */}
                <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={15} />
                <br />
                <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={22} />
                </h1>
                <h2>Mathematician / Cryptography Enthusiast / Frontend Developer</h2>
                <Link to='/contact' className='flat-button'>REACH OUT</Link>
            </div>
            {/* Logo would go here */}
        </div>
        <Loader type='pacman' />
        </>
    )
}

export default Home
